// Where the reader was in the feed when they opened a report, keyed by the
// hub's history entry, so Back lands on the same card at the same height.
// In memory only: a reload starts the feed from the top, as any reload does.

export interface FeedAnchor {
  /** The opened card's `itemKey`. */
  key: string;
  /** Its top edge, in viewport pixels, when it was opened. */
  top: number;
}

const anchors = new Map<string, FeedAnchor>();

export const rememberFeedAnchor = (entry: string, anchor: FeedAnchor): void => {
  anchors.set(entry, anchor);
};

/** The anchor for this history entry, once. */
export const takeFeedAnchor = (entry: string): FeedAnchor | null => {
  const anchor = anchors.get(entry) ?? null;
  anchors.delete(entry);
  return anchor;
};
